//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MaterialInput from "../inputs/material-input.vue";
import SectionError from "./section-error";
import { v4 as uuidv4 } from "uuid";
import { isEmpty } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "SelectSection",
  components: {
    SectionError,
    MaterialInput
  },
  provide() {
    //mostly needed for address custom section - but can be augmented
    if (this.$validator && this.appendValidatorPath) {
      return {
        $validator: {
          value: this.$validator.value[this.name]
        }
      };
    }
  },
  inject: {
    $validator: {
      default: null
    }
  },
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    id: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: null,
      default: ""
    },
    tabindex: {
      type: [String, Number],
      default: "0"
    },
    containerClass: {
      type: String,
      default: ""
    },
    className: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholderOption: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: ""
    },
    translationMap: {
      type: Object,
      default: null
    },
    appendValidatorPath: {
      type: Boolean,
      default: false
    },
    hiddenLabel: {
      type: Boolean,
      default: false
    },
    labelFor: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      labelValue: isEmpty(this.labelFor) ? uuidv4() : this.labelFor,
      previousValue: this.value
    };
  },
  computed: {
    inputVal() {
      return this.value;
    },
    defaultSelect() {
      return this.inputVal ? "selected" : "false";
    },
    selectClassName() {
      const classes = [];
      if (this.inputVal === "" || this.inputVal === null) {
        classes.push("select-field-empty");
      }
      if (this.label) {
        classes.push("material-input-static-label");
      }
      classes.push(this.className);
      return classes.join(" ");
    },
    containerClassName() {
      return `${this.errorMessage ? "error" : ""} ${this.containerClass}`;
    }
  },
  watch: {
    value(value, previousValue) {
      this.previousValue = previousValue;
    }
  },
  methods: {
    handleInput({
      target
    }) {
      let value = target.value;
      if (value === "true") {
        value = true;
      }
      if (value === "false") {
        value = false;
      }
      this.$emit("previousValue", this.previousValue);
      this.$emit("change", value);
    },
    setSelectedOption(option) {
      return option.value === this.inputVal;
    }
  }
});